import { Typography } from "@mui/material";

// NS-753
function NoPermission() {
    return <>
        <Typography variant="h4">No Permission</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ marginTop: "10px" }}>
            Your role does not allow access to this page.
        </Typography>
    </>;
}


export default NoPermission;
